<template>
  <div>
    <div class="h-title">偏远邮编查询</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :model="form" :inline="true" size="small">
          <el-form-item label="邮编">
            <el-input v-model="form.zipcode" type="textarea" placeholder="请输入邮编"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query">搜索</el-button>
          </el-form-item>
        </el-form>
        <div v-show="in_configs(71501)">
          <el-button size="small" class="btn-cyan" @click="dialogUpLoadVisible = true">导入</el-button>
        </div>
      </div>
    </el-card>
    <el-table :data="tableData">
      <el-table-column prop="zipcode" label="邮编" width="180"/>
      <el-table-column prop="desc" label="描述" width="180"/>
      <el-table-column prop="country" label="国家" width="180"/>
    </el-table>
    <el-dialog title="上传" :visible.sync="dialogUpLoadVisible" width="60%">
      <el-upload :action="baseUrl" :on-success="uploadCallBack" name="file" :limit="1" :file-list="fileList" accept=".xlsx" :with-credentials="true" :show-file-list="false" style="display: inline-block;">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
     return {
      baseUrl: tmsSpringUrl + "op/remote-zipcode/parse",
      fileList: [],
      dialogUpLoadVisible: false,
      form:{
        zipcode: ''
      },
      tableData: []
     } 
    },
    methods: {
      uploadCallBack(res) {
        if (!res.success) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error',
            duration: 0
          })
          this.fileList = []
          return
        }
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success' 
        })
        this.fileList = []
        this.dialogUpLoadVisible = false
      },
      query(){
        let _this = this
        this.$request1.post('op/remote-zipcode',
        {
              zipcode: this.form.zipcode
        },
        {
          withCredentials: true,
        }
        ).then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.tableData = response.data.data;
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/system/remote_zipcode.vue